import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ResultsMetrics = () => {
  const { t } = useTranslation();
  const results = t('home.results', { returnObjects: true });

  return (
    <section data-testid="results-section" className="py-16 md:py-20 border-t border-white/5">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {results.map((r, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="text-center">
              <p className="text-[#c8ff00] text-4xl md:text-5xl font-bold font-['Syne']">{r.metric}</p>
              <p className="text-gray-400 text-sm mt-2">{r.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResultsMetrics;
